import React, { useMemo, useState } from 'react'
import history from 'services/history'
import request from 'services/http'
import { tap, finalize } from 'rxjs/operators'
import PageLoader from 'components/PageLoader'
import { useSubscription } from 'utils'
import { Divider, Icon, Button, Form } from 'semantic-ui-react'
import { numFormat } from '@rededompedro/utils'
import DetalhaValores from './DetalhaValores'

export default function ConferenciaResult({ conferencia, setConferencia, empresas, path }) {

    const [isFetching, setIsFetching] = useState(conferencia ? false : true)
    const [detail, setDetail] = useState(null)
    
    const params = Object.fromEntries(new URLSearchParams(history.location.search.replace("?=", '')).entries())
    const emp = empresas.find(it => it && it._id === parseInt(params.empresa))

    const fetchDados$ = useMemo(() => request({
        url: '/nfce/conferencia',
        method: 'GET',
        params
    }).pipe(
        tap(({ response }) => setConferencia(response)),
        finalize(() => setIsFetching(false))
    ), [setConferencia, params])

    useSubscription(fetchDados$, !conferencia && empresas.length > 0)

    function goBack() {
        history.replace(`${path}/relatorios`)
    }

    function handleClick(_, { datavalue }) {
        setDetail(datavalue)
    }

    return (
        <PageLoader active={isFetching} content='Carregando dados...'>
            <div className="row mt-2">
                <div className="col-12 col-md d-flex align-items-end">
                    <p className='mb-0'>
                        <strong>Empresa: </strong> {emp ? emp.nomeEmpresa : ''} - {params.dataInicial + ' / ' + params.dataFinal}
                        <strong className='pl-2'>Receita Fiscal:</strong> {numFormat(conferencia ? conferencia.nEmi + conferencia.nCor : 0)}
                    </p>
                </div>
                <div className='col-12 col-md-2 d-print-none'>
                    <Button icon size='tiny' className='btn-red' floated='right' onClick={goBack}>
                        <Icon name='arrow left' /> Voltar
                    </Button>
                </div>
            </div>

            <Divider className='mt-2 custom-divider darken' fitted />

            <div className="row mt-2">
                <div className="col">
                    {conferencia && <Form size='small'>
                        <div className="row">
                            <div className="col">
                                <Form.Input readOnly value={numFormat(conferencia.vDet)} label='Venda Detalhada' 
                                    icon={<Icon onClick={handleClick} name='search' datavalue='vendaDetalhada' color='green' inverted circular link />} />
                            </div>
                            <div className="col">
                                <Form.Input readOnly value={numFormat(conferencia.nEmi)} label='Notas Emitidas' />
                            </div>
                            <div className="col">
                                <Form.Input readOnly value={numFormat(Math.abs(conferencia.nEmi - conferencia.vDet))} label='Notas Emitidas - Venda detalhada' />
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-2">
                                <Form.Input readOnly value={numFormat(conferencia.nCompl)} label='Notas Complementares' />
                            </div>
                            <div className="col-2">
                                <Form.Input readOnly value={numFormat(conferencia.nFat)} label='Notas de Faturamento' />
                            </div>
                            <div className="col-2">
                                <Form.Input readOnly value={numFormat(conferencia.dup)} label='Duplicidades' />
                            </div>
                            <div className="col-2">
                                <Form.Input readOnly value={numFormat(conferencia.vRej)} label='Vendas Rejeitadas' />
                            </div>
                            <div className="col-2">
                                <Form.Input readOnly value={numFormat(conferencia.nCor)} label='Correção mês anterior' />
                            </div>
                            <div className="col-2">
                                <Form.Input readOnly value={numFormat(conferencia.vSNum)} label='Vendas S/Número' />
                            </div>
                        </div>
                        <div className="row mt-2">
                        </div>
                    </Form>}
                </div>
            </div>

            <Divider className='mt-2 custom-divider darken' fitted />

            <div className="row mt-2 d-flex flex-grow-1">
                <div className="col">
                    {!detail && <p>Selecione algum campo acima para detalhar valores (clicando no botão "verde").</p>}
                    {detail && <DetalhaValores field={detail} {...params} />}
                </div>
            </div>
            
        </PageLoader>
    )
}
